var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { Renderer } from "./Renderer";
import { defineCustomTags } from "sb-resp-lib";
defineCustomTags("sb-lazy-render");
var LazyRender = /** @class */ (function (_super) {
    __extends(LazyRender, _super);
    function LazyRender(props) {
        var _this = _super.call(this, props) || this;
        _this.refRoot = React.createRef();
        _this.state = {
            renderer: new Renderer(_this.props.observerOptions || {})
        };
        return _this;
    }
    LazyRender.prototype.componentWillUnmount = function () {
        if (this.refRoot.current) {
            this.state.renderer.unRegisterDom(this.refRoot.current);
        }
    };
    LazyRender.prototype.componentDidMount = function () {
        if (this.refRoot.current) {
            this.state.renderer.registerDom(this.refRoot.current);
        }
    };
    LazyRender.prototype.render = function () {
        // TODO: improve the render method to lower complexity and increase coverage
        var children = this.props.children;
        if (typeof this.props.contentCallback === "function" &&
            this.state.renderer.isVisible) {
            children = this.props.contentCallback();
        }
        return (React.createElement("sb-lazy-render", { style: { minHeight: this.props.baseMinHeight }, ref: this.refRoot }, this.state.renderer.isVisible && children));
    };
    LazyRender = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], LazyRender);
    return LazyRender;
}(React.Component));
export { LazyRender };
//# sourceMappingURL=LazyRender.js.map